import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {DatePipe} from '@angular/common';
import {Store} from '@ngrx/store';
import {ProjectComponent} from '../../../../../store/entities/projects/project-component/project-component.model';
import {Project} from '../../../../../store/entities/projects/project/project.model';
import {
  editProjectComponent,
  saveProjectComponent
} from '../../../../../store/entities/projects/project-component/project-component.actions';
import {AppState} from '../../../../../store/entities';

@Component({
  selector: 'app-project-component-form',
  templateUrl: './project-component-form.component.html',
  styleUrls: ['./project-component-form.component.scss']
})
export class ProjectComponentFormComponent implements OnInit {

  title: string;
  component: ProjectComponent;
  project: Project;
  form: UntypedFormGroup;

  constructor(
    private fb: UntypedFormBuilder,
    private store: Store<AppState>,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.project = data?.project;
    this.component = data?.component;
  }

  ngOnInit(): void {
    this.title = this.component ? 'Edit ' : ' Add ' + 'Project Component';

    this.form = this.fb.group({
      name: [null, Validators.required],
      location: [null, Validators.required],
      manager: [null, Validators.required],
      startDate: [null, Validators.required],
      handoverDate: [null, Validators.required],
      details: [null, Validators.required],
      budget: [null, Validators.required],
      percentCompositionOnProject: [null, Validators.required],
      project: [this.project?.uniqueId, Validators.required],
    });

    if (this.component) {
      this.form.patchValue(this.component);
    }
  }

  add(formData) {
    formData.startDate = new DatePipe('en-GB').transform(formData.startDate, 'yyyy-MM-dd');
    formData.handoverDate = new DatePipe('en-GB').transform(formData.handoverDate, 'yyyy-MM-dd');

    if (this.component){
      formData.uniqueId = this.component?.uniqueId;
      this.store.dispatch(editProjectComponent({ formData }));
    }else {
      this.store.dispatch(saveProjectComponent({ formData }));
    }
  }
}
